import { isUndefined } from 'lodash-es';
import * as t from 'io-ts';

import type { HierarchyCustomizationDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface HierarchyValuesSettingDefinition extends HierarchyCustomizationDefinition {
    key: 'HIERARCHY_VALUES';
}

const DEFAULT_HIERARCHY_VALUES: string[] = [];

const definition: HierarchyValuesSettingDefinition = {
    key: 'HIERARCHY_VALUES',
    type: 'HierarchyCustomizationInput',
    label: 'Hierarchy values',
    value: DEFAULT_HIERARCHY_VALUES,
    options: [],
    scope: 'designer',
    lazy: 'uninitialized',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.array(t.string));

export const codec = specSettingsInterface.input;

export const HierarchyValuesSettingDefinition = define({
    key: 'HIERARCHY_VALUES',
    label: 'HierarchyValues',
    definition,
    fromSetting: settings => {
        if (isUndefined(settings.hierarchyId)) return undefined;
        if (isUndefined(settings.hierarchyValues)) return [];

        return specSettingsInterface.extractValue(settings.hierarchyValues);
    },
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings => {
        if (isUndefined(settings.hierarchyId)) return undefined;

        return specSettingsInterface.createDefinitionWithSettings(
            settings.hierarchyValues || DEFAULT_HIERARCHY_VALUES,
        );
    },

    applySettingDependency: ({ diff }) => {
        const hierarchyIdChanged = !!diff.HIERARCHY_ID && !!diff.HIERARCHY_ID.previous;

        return hierarchyIdChanged ? { value: [] } : undefined;
    },
});
